export enum RoleMatch {
  ANY = 'ANY',
  ALL = 'ALL',
  NONE = 'NONE',
}
